import {
  useEffect
} from 'react';
import './PurchaseConfirmationModal.css';
import {
  AdvisoryContent, ContentView, ViewElement
} from '../../../../common/global-types/AdvisoryContent';
import useTracking from '../../../../common/tracking/useTracking';

type PurchaseConfirmationModalProps = {
  view: ContentView;
  setModalMaxWidth: (viewId: number) => void;
  content: AdvisoryContent
};

function PurchaseConfirmationModal({
  view,
  setModalMaxWidth,
  content
}:PurchaseConfirmationModalProps) {
  const viewElements = view.viewElements as ViewElement;

  const trackVisibilityElement = useTracking(content, view.contentViewId);

  useEffect(() => {
    setModalMaxWidth(660);
  }, []);

  return (
    <div id="purchase-confirmation">
      <div className="main">
        <div className="circle">
          <ids-icon check ui-24 />
        </div>
        <h2 className="if typography heading large" ref={trackVisibilityElement}>{viewElements.headlines?.[0]}</h2>
        <p className="if typography paragraph medium brown-700">{viewElements.paragraphs?.[0]}</p>
      </div>
      <div className="if card elevated">
        <div className="if card-content">
          <span className="if typography ui small brown-700">{viewElements.paragraphs?.[2]}</span>
          <span className="if typography ui large">{viewElements.paragraphs?.[3]}</span>
          <span className="if typography ui small brown-700">{viewElements.paragraphs?.[4]}</span>
          <span className="if typography ui large">{viewElements.paragraphs?.[5]}</span>
        </div>
      </div>
      <p className="if typography paragraph small brown-700 withdrawal-information">{viewElements.paragraphs?.[1]}</p>
    </div>
  );
}

export default PurchaseConfirmationModal;
